import React from 'react';
import '../App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/free-solid-svg-icons';
import { CircleLoader } from 'react-spinners';

interface props {
    type: string,
    text?: string,
    callback: () => void,
    disabled?: boolean,
    loading?: boolean
}

function Button({type, text, callback, disabled, loading}: props) {
    return (
        <button disabled={disabled} className={`${type}-button ${disabled ? 'disabled' : ''}`} onClick={() => callback()}>
            {loading && loading === true ? <CircleLoader color="#FFFFFF" size={24}/> : text} {type === 'scroll' && <FontAwesomeIcon icon={faArrowDown} className='arrow-down'/>}
        </button>
    );
}

export default Button;
